export default __webpack_public_path__ + "457f5f5afebcd7f2a84101d9b8288795.png";